<div class="showcase-wrapper">
  <div class="header-wrapper">
    <div class="dots" *ngIf="(data?.length ?? 0) > 1">
      <div
        *ngFor="let item of data; let i = index"
        class="dot"
        [class.active]="i === currentIndex"
        [class.hidden]="!isDotVisible(i)">
      </div>
    </div>
  </div>

  <!-- Animated wrapper -->
  <div class="component-wrapper" *ngIf="data && (data.length ?? 0) > 0">
    <div
      class="component-inner"
      [@fadeSwitch]="currentIndex"
    >
      <ng-container
        *ngComponentOutlet="itemComponent; injector: injectors[currentIndex]"
      ></ng-container>
    </div>
  </div>
</div>
